/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { DirtyType } from '@gh/common-shared-data';
import { entity, enumeration } from '@gh/core-data';
import { RfqHeadingListItemDto } from './rfq-structure.dto';

export const RfqHeadingListItemMapper = entity<RfqHeadingListItemDto>({
  dirtyType: enumeration(DirtyType),
});
